/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type IrrCloudProvider = 'UNKNOWN_ENTITY' | 'AWS' | 'GCP';

export const IrrCloudProvider = {

    UNKNOWN_ENTITY: 'UNKNOWN_ENTITY' as IrrCloudProvider,

    AWS: 'AWS' as IrrCloudProvider,

    GCP: 'GCP' as IrrCloudProvider
};

